const translations = {
  title: 'Rotinas',
  title_routines: 'Rotinas',
  new_routines: 'Nova Rotina',
  new: 'Nova Rotina',
  modalTitle: 'Nova rotina',
  modalTitle_edit: 'Editando rotina',
  name: 'Nome',
  nameRequired: 'Nome*',
  folder: 'Pasta',
  quantity: 'Quantidade',
  activitiesRequired: 'Atividades*',
  configureActivities: '+ Configurar Atividades',
  customizeRecurrence: 'Personalizar Recorrência*',
  repeatEvery: 'Repetir a cada',
  repeat: 'Repetir',
  startsAt: 'Começa em',
  endsAt: 'Termina',
  never: 'Nunca',
  on: 'Em',
  'frequencyOptions.day': 'Dia',
  'frequencyOptions.week': 'Semana',
  'frequencyOptions.year': 'Ano',
  mustHaveAtLeastOneActivity: 'Deve ter pelo menos 1 atividade',
  checkActivities: 'Verifique as atividades',
  cannotBeLessOrEqualToZero: 'Não pode ser menor ou igual a zero',
  startDateMustBeGreaterThanCurrent: 'A data de início precisa ser maior que a data atual.',
  endDateMustBeGreaterThanStart: 'A data de término precisa ser maior que a data de início.'
}

export default translations
